'use strict';

var SoftScroll = require('../../soft-scroll/soft-scroll');
var MainHeader = require('../../main-header/main-header');
var MainHeaderNavs = require('../../main-header/lib/navs');
var MegamenuVisibility = require('../../megamenu/lib/visibility');
var Overlay = require('../../overlay/overlay');

var NavSoftScroll = function(config) {

  var self = this;
  var $nav = $(config.nav);
  var $link = $nav.find('a');
  var $html = $('html');

  self.parseLinks = function() {
    $link.each(function() {
      var $this = $(this);
      var href = $this.attr('href');

      if (href.indexOf('#') > -1) {
        var str = href.split('#', 2);
        var $target = $('#' + str[1]);

        if ($target.length) {
          self.clickHandler($this, $target);
        }
      }
    });
  }

  self.clickHandler = function($link, $target) {
    $link.on('click.navSoftScroll', function(e) {
      e.preventDefault();
      self.mainHeaderNavsVisibility();
      self.megamenuVisibility();
      new SoftScroll().scrollAnimation($target);
    });
  }

  self.mainHeaderNavsVisibility = function() {

    if ($html.hasClass('main-header-navs-open')) {

      var mainHeaderConfig = new MainHeader().config;
      var navsConfig = {
        navs: mainHeaderConfig.navs
      };
      new MainHeaderNavs(navsConfig).hideNavs();
    }
  }

  self.megamenuVisibility = function() {

    if ($html.hasClass('megamenu-is-open')) {

      new MegamenuVisibility({
        megamenuItem: '.megamenu__item',
        megamenuItemGrid: '.megamenu__item-grid'
      }).hideCurrentSubnavs(null, null, true, true);
      new Overlay().hideOverlay();
    }
  }

  self.init = function() {
    self.parseLinks();
  }
};

module.exports = NavSoftScroll;
